import { Checkbox, FormControlLabel } from "@mui/material";
import WorkLogReport from "../../models/WorkLogReport";
import useWeeklyValidation from "../../hooks/useWeeklyValidation";

export const WorkLogWeeklyValidationCheckboxComponent = (props: {
  instance: WorkLogReport;
  date: Date;
  week: string;
  rows: WorkLogReport[];
  setRows: React.Dispatch<React.SetStateAction<WorkLogReport[]>>;
  canEdit: boolean;
}): JSX.Element => {
  const { buttonChecked, handleChange } = useWeeklyValidation({
    instance: props.instance,
    date: props.date,
    week: props.week,
    setRows: props.setRows,
  });

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={buttonChecked}
          onChange={(event) => handleChange(event.target.checked)}
          color="default"
          disabled={!props.canEdit}
        />
      }
      style={{ marginLeft: 0, marginRight: -8 }}
      label=""
    />
  );
};
